import {BaseModel} from "@shared/models/base.model";
import {
  InAppNotificationEnum,
  InAppNotificationLogType, Maybe, Scalars, UserType,
} from '@generated/graphql';
import {User} from "@modules/user/models/user.model";
import {userFactory} from "@modules/user/factories/user.factory";
import { DateTime } from "luxon";
import {parseAnyDate} from "@shared/helpers/date-time.helpers";

export const icons: Record<InAppNotificationEnum, string> = {
  [InAppNotificationEnum.Conversation]: 'noti-unread-message.svg',
  [InAppNotificationEnum.JobRequest]: 'noti-job-request.svg',
  [InAppNotificationEnum.JobAssigned]: 'noti-job-assigned.svg',
  [InAppNotificationEnum.JobDone]: 'noti-job-done.svg',
  [InAppNotificationEnum.RegisterCompany]: 'noti-register-company.svg',
  [InAppNotificationEnum.TransferCompany]: 'noti-transfer-company.svg',
  [InAppNotificationEnum.PaymentReceived]: 'noti-payment-receive.svg',
  [InAppNotificationEnum.PaymentProcess]: 'noti-payment-process.svg',
  [InAppNotificationEnum.PaymentApproved]: 'noti-payment-approved.svg',
  [InAppNotificationEnum.PaymentRejected]: 'noti-payment-rejected.svg',
  [InAppNotificationEnum.CompanyProfileCreated]: 'noti-default.svg',
  [InAppNotificationEnum.CompleteKyc]: 'noti-default.svg',
  [InAppNotificationEnum.ExtraJobCreated]: 'noti-default.svg',
  [InAppNotificationEnum.ExtraJobDone]: 'noti-default.svg',
  [InAppNotificationEnum.JobDone]: 'noti-default.svg',
  [InAppNotificationEnum.JobCreated]: 'noti-default.svg',
  [InAppNotificationEnum.FileReady]: 'noti-default.svg'
}

export class InAppNotificationLog extends BaseModel implements InAppNotificationLogType {
  id: string;
  description?: string;
  details?: string;
  entityId?: string;
  isRead?: boolean;
  isSent?: boolean;
  type?: string;
  user?: User;
  userId?: string
  __typename?: 'InAppNotificationLogType';

  constructor(state) {
    super(state);

    this.user = userFactory.tryCreating(state.user)

    this.createdAt = parseAnyDate(state.createdAt)
  }

  getModelName(): string {
    return InAppNotificationLog.name;
  }

  icon (): string {
    const prefix = 'assets/images/icons/';

    return prefix + (icons[this.type] ?? 'noti-default.svg');
  }
}
